
import { useParams } from 'react-router-dom';

import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { CargandoMedio, FBAFuncion, FormDescartesPlanilla } from "../../components";
import { useDescartesXPlanilla, useModales } from '../../../hooks';
import { DisenioPlanilla } from '../../layout';
import { ModalFormUno } from '../../components/components/ModalFormUno';







export const ListadoMermas = () => {


    const { id } = useParams();
    const { handleAbrilModal, handleCerrarModal } = useModales();
    const { descartesXPlaniQuery } = useDescartesXPlanilla(id);
    console.log(descartesXPlaniQuery.data);




    return (

        <DisenioPlanilla titulo="Listado de Mermas">
            {(descartesXPlaniQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Cargueros..." />
            :   <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto'}}>
                    <TableContainer>
                        <Table sx={{minWidth:700, overflowX:'auto'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width:'5%'}}>#</TableCell>
                                    <TableCell sx={{width:'35%'}}>TIPO</TableCell>
                                    <TableCell sx={{width:'20%'}}>CANTIDAD</TableCell>
                                    <TableCell sx={{width:'20%'}}>PESO</TableCell>
                                    <TableCell sx={{width:'20%'}}>VALOR</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {descartesXPlaniQuery.data.length > 0 ? (
                                descartesXPlaniQuery.data.map((item, index) => (
                                    <TableRow key={item.id}>
                                        {/* <TableCell>{index + 1}</TableCell>
                                        <TableCell>{item?.usuario?.nombre}</TableCell>
                                        <TableCell>{item?.usuario?.movil}</TableCell>
                                        <TableCell>{`$${separadorMillares(item.valor)}`}</TableCell> */}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow><TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                        No hay mermas en el momento...
                                </TableCell></TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            }

            <FBAFuncion funcion={ handleAbrilModal } icono="plus" />
            <ModalFormUno titulo="Agregar Descarte" valor={{}} onClose={handleCerrarModal}>
                <FormDescartesPlanilla />
            </ModalFormUno>
        </DisenioPlanilla>

    )
}
